import React, { useState, useEffect, useRef } from "react";
import { 
    Card, Row, Col, Button, Badge, Table, Spinner, Alert, 
    Modal, Form, Tooltip, OverlayTrigger 
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { formatCurrency, formatDate, formatNumber } from "../utils/formatters";
import logo from "../assets/img/logo.jpeg";
import './Factures.css';
 
export default function DetailDevis() {
    const navigate = useNavigate();
    const { id } = useParams();
    const printRef = useRef();
    
    const [devis, setDevis] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showConvertModal, setShowConvertModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [societeInfos, setSocieteInfos] = useState(null);
    const [logoBase64, setLogoBase64] = useState('');


const [logoUrl, setLogoUrl] = useState(''); // Pour stocker l'URL du logo
    
    // ÉTATS POUR LES TAXES
    const [taxes, setTaxes] = useState({
        tva_taux: 18,
        css_taux: 1,
        tva_active: true,
        css_active: true
    });
    
    // États pour les alertes
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

useEffect(() => {
    const loadAllData = async () => {
        try {
            setLoading(true);
            await Promise.all([
                fetchDevis(),
                fetchTaxes(),
                fetchSocieteInfos(),
                loadLogoBase64()
            ]);
        } catch (error) {
            console.error("Erreur lors du chargement des données:", error);
        } finally {
            setLoading(false);
        }
    };
    
    loadAllData();
}, [id]);

// Modifiez fetchDevis pour retourner une promesse
const fetchDevis = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            `https://sawd.julesferry-ga.com/api/devis.php?id=${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        );

        if (!response.ok) throw new Error("Erreur chargement");
        
        const result = await response.json();
        setDevis(result.data);
        return result.data;
    } catch (err) {
        setError(err.message);
        throw err; // Important pour que Promise.all attrape l'erreur
    }
};

// Modifiez fetchTaxes pour retourner une promesse
const fetchTaxes = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            'https://sawd.julesferry-ga.com/api/parametres.php?action=taxes',
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        if (response.ok) {
            const result = await response.json();
            if (result.data) {
                setTaxes(result.data);
                return result.data;
            }
        }
    } catch (err) {
        console.error("Erreur chargement taxes", err);
        throw err;
    }
};

// Modifiez fetchSocieteInfos pour retourner une promesse
// Dans fetchSocieteInfos, stockez l'URL du logo
const fetchSocieteInfos = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            'https://sawd.julesferry-ga.com/api/parametres.php?action=societe',
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        if (response.ok) {
            const result = await response.json();
            if (result.data) {
                setSocieteInfos(result.data);
                // L'URL du logo est déjà dans result.data.logo_url
                console.log("Logo URL:", result.data.logo_url); // Vérification
            }
        }
    } catch (err) {
        console.error("Erreur chargement société", err);
    }
};
// loadLogoBase64 retourne déjà une promesse, c'est bon
const loadLogoBase64 = () => {
    return new Promise((resolve) => {
        try {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/jpeg');
                setLogoBase64(dataURL);
                resolve(dataURL);
            };
            
            img.onerror = () => {
                console.warn("Impossible de charger le logo");
                setLogoBase64('');
                resolve('');
            };
            
            img.src = logo;
        } catch (error) {
            console.error("Erreur chargement logo:", error);
            setLogoBase64('');
            resolve('');
        }
    });
};


    // STYLES CSS POUR L'IMPRESSION
    const printStyles = `
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            background: #f5f7fa;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
            padding: 30px;
            color: #2c3e50;
        }

        .document-paper {
            max-width: 900px;
            margin: 0 auto;
            background: white;
            box-shadow: 0 5px 20px rgba(0,0,0,0.1);
            padding: 30px 35px;
            border-radius: 8px;
        }

        /* En-tête */
        .document-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 25px;
            padding-bottom: 20px;
            border-bottom: 2px solid #4361ee;
        }

        .company-info h1 {
            font-size: 1.8rem;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 5px;
        }

        .company-details {
            font-size: 0.85rem;
            color: #5a6a7e;
            line-height: 1.5;
            margin-top: 5px;
        }

        .company-details span {
            display: inline-block;
            margin-right: 20px;
        }

        .document-badge {
            text-align: right;
        }

        .document-badge .doc-type {
            font-size: 1.2rem;
            font-weight: 600;
            color: #4361ee;
            margin-bottom: 5px;
        }

        .document-badge .doc-number {
            font-size: 0.9rem;
            color: #5a6a7e;
            background: #f1f5f9;
            padding: 4px 12px;
            border-radius: 4px;
            display: inline-block;
        }

        .status-badge {
            display: inline-block;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 0.8rem;
            font-weight: 600;
            text-transform: uppercase;
            margin-top: 8px;
        }

        .status-badge.brouillon { background: #e2e8f0; color: #475569; }
        .status-badge.envoye { background: #dbeafe; color: #1e40af; }
        .status-badge.accepte { background: #d1fae5; color: #065f46; }
        .status-badge.refuse { background: #fee2e2; color: #991b1b; }
        .status-badge.converti_facture { background: #8b5cf6; color: white; }
        .status-badge.expire { background: #f59e0b; color: white; }

        /* Section client */
        .client-section {
            background: #f8fafc;
            padding: 20px;
            border-radius: 6px;
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }

        .client-info h3 {
            font-size: 0.8rem;
            font-weight: 600;
            color: #4361ee;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            margin-bottom: 12px;
        }

        .client-name {
            font-size: 1.2rem;
            font-weight: 600;
            color: #1e293b;
            margin-bottom: 8px;
        }

        .client-details {
            font-size: 0.85rem;
            color: #4a5a6e;
            line-height: 1.6;
        }

        .client-details span {
            display: block;
        }

        .document-dates {
            text-align: right;
        }

        .date-item {
            margin-bottom: 8px;
        }

        .date-item .label {
            font-size: 0.75rem;
            color: #6f7d95;
            display: block;
        }

        .date-item .value {
            font-size: 1rem;
            font-weight: 500;
            color: #1e293b;
        }

        .date-item.expired .value {
            color: #dc2626;
        }

        .validity-badge {
            font-size: 0.8rem;
            padding: 4px 10px;
            background: #fef3c7;
            color: #92400e;
            border-radius: 4px;
            display: inline-block;
            margin-top: 5px;
        }

        .validity-badge.expired {
            background: #fee2e2;
            color: #991b1b;
        }

        /* Notes */
        .notes-section {
            background: #fef9e7;
            padding: 12px 15px;
            border-left: 3px solid #f59e0b;
            margin: 20px 0;
            font-size: 0.9rem;
            color: #4a5a6e;
        }

        .notes-section strong {
            color: #b45309;
            margin-right: 8px;
        }

        /* Tableau */
        .table-container {
            margin: 25px 0;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            overflow: hidden;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.85rem;
        }

        th {
            background: #f1f5f9;
            color: #1e293b;
            font-weight: 600;
            padding: 12px 10px;
            text-align: left;
            border-bottom: 1px solid #cbd5e1;
        }

        td {
            padding: 10px;
            border-bottom: 1px solid #e2e8f0;
        }

        tr:last-child td {
            border-bottom: none;
        }

        .ref-cell {
            font-family: 'Courier New', monospace;
            font-size: 0.8rem;
            color: #4361ee;
            background: #eef2ff;
            padding: 3px 8px;
            border-radius: 3px;
            display: inline-block;
        }

        .amount-cell {
            text-align: right;
            font-weight: 500;
        }

        .text-center {
            text-align: center;
        }

        /* Totaux */
        .totals-wrapper {
            display: flex;
            justify-content: flex-end;
            margin-top: 20px;
        }

        .totals-card {
            width: 350px;
        }

        .total-line {
            display: flex;
            justify-content: space-between;
            padding: 8px 0;
            border-bottom: 1px dashed #d1d9e6;
        }

        .total-line:last-child {
            border-bottom: none;
        }

        .total-line .label {
            color: #4a5a6e;
        }

        .total-line .value {
            font-weight: 500;
        }

        .total-line.highlight {
            background: #f1f5f9;
            margin-top: 8px;
            padding: 12px;
            border-radius: 4px;
            font-weight: 600;
        }

        .total-line.highlight .label,
        .total-line.highlight .value {
            color: #4361ee;
            font-size: 1.1rem;
        }

        /* Pied de page */
        .document-footer {
            margin-top: 35px;
            padding-top: 15px;
            border-top: 1px solid #d1d9e6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.75rem;
            color: #7f8c9f;
        }

        .legal-info span {
            margin-right: 20px;
        }

        .signature-area {
            text-align: right;
        }

        .signature-line {
            margin-top: 5px;
            font-style: italic;
        }

        @media print {
            body {
                background: white;
                padding: 0;
            }
            .document-paper {
                box-shadow: none;
                padding: 20px;
            }
            th {
                background: #f1f5f9 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        }
    `;

    // Charger les infos société
 


    // FONCTION POUR CHARGER LES TAXES

    const showSuccess = (message) => {
        setSuccessMessage(message);
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000);
    };

    const showError = (message) => {
        setErrorMessage(message);
        setShowErrorAlert(true);
        setTimeout(() => setShowErrorAlert(false), 3000);
    };

    const handleConvertirEnFacture = async () => {
        setSaving(true);

        try {
            const userStr = localStorage.getItem("user");
            const user = userStr ? JSON.parse(userStr) : null;
            const token = localStorage.getItem("token");

            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/devis.php',
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'convertir',
                        id_devis: id,
                        id_utilisateur: user?.id
                    })
                }
            );

            const result = await response.json();

            if (result.success) {
                setShowConvertModal(false);
                fetchDevis();
                showSuccess("Devis converti en facture avec succès");
                setTimeout(() => {
                    navigate('/ventes/factures');
                }, 2000);
            } else {
                showError(result.message || "Erreur lors de la conversion");
            }
        } catch (err) {
            showError("Erreur de connexion");
        } finally {
            setSaving(false);
        }
    };
 const companie = {
        name: societeInfos?.nom || 'GESTION STOCK',
        address: societeInfos?.adresse || '123 Rue du Commerce, Libreville',
        phone: societeInfos?.telephone || '+241 01 23 45 67',
        email: societeInfos?.email || 'contact@gestionstock.ga',
        site_web: societeInfos?.site_web || 'www.gestionstock.ga',
        rc: societeInfos?.rc || 'LB/2025/00123',
        nif: societeInfos?.nif || '20251234567',
        patente: societeInfos?.patente || 'PAT0012345',
        logo_url: societeInfos?.logo_url // Ajoutez le logo
    };
    // Fonction pour générer le HTML d'impression
const genererHTMLImpression = () => {
    if (!devis) return '';
 
    const company = {
        name: societeInfos?.nom || 'GESTION STOCK',
        address: societeInfos?.adresse || '123 Rue du Commerce, Libreville',
        phone: societeInfos?.telephone || '+241 01 23 45 67',
        email: societeInfos?.email || 'contact@gestionstock.ga',
        site_web: societeInfos?.site_web || 'www.gestionstock.ga',
        rc: societeInfos?.rc || 'LB/2025/00123',
        nif: societeInfos?.nif || '20251234567',
        patente: societeInfos?.patente || 'PAT0012345',
        logo_url: societeInfos?.logo_url // Ajoutez le logo
    };
 
    const statutConfig = {
        brouillon: { class: 'brouillon', label: 'BROUILLON' },
        envoye: { class: 'envoye', label: 'ENVOYÉ' },
        accepte: { class: 'accepte', label: 'ACCEPTÉ' },
        refuse: { class: 'refuse', label: 'REFUSÉ' },
        converti_facture: { class: 'converti_facture', label: 'CONVERTI' }
    };

    const estExpire = devis && new Date(devis.date_validite) < new Date();
    const statut = devis?.statut === 'envoye' && estExpire 
        ? { class: 'expire', label: 'EXPIRÉ' }
        : statutConfig[devis?.statut] || statutConfig.brouillon;

    const joursRestant = Math.ceil((new Date(devis.date_validite) - new Date()) / (1000 * 60 * 60 * 24));
     
    // Utiliser le logo de l'API ou un fallback
    const logoSrcv = company.logo_url || ''; // URL ou base64 de l'API
    const logoText = company.name.substring(0, 2).toUpperCase();
 console.log(logoSrcv);
    return ` 
        <!DOCTYPE html>
        <html lang="fr">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Devis ${devis.numero_proforma}</title>
            <style>
                ${printStyles}
                .logo {
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                }
                .logo-fallback {
                    width: 80px;
                    height: 80px;
                    background: linear-gradient(135deg, #4361ee, #3a56d4);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 2rem;
                    border-radius: 12px;
                    box-shadow: 0 2px 10px rgba(67, 97, 238, 0.3);
                }
                .company-info-detail {
                    display: flex;
                    flex-direction: column;
                }
                .company-name {
                    font-size: 1.8rem;
                    font-weight: 700;
                    color: #1e293b;
                    line-height: 1.2;
                }
                .company-website {
                    font-size: 0.8rem;
                    color: #64748b;
                }
            </style>
        </head>
        <body>
            <div class="document-paper">
                <!-- En-tête avec logo -->
                <div class="document-header" style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <div style="display: flex; align-items: center; gap: 15px;">
                        ${logoSrcv ? `
                            <img src="${company.logo_url}" alt="Logo ${company.name}" class="logo" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'; console.log('Erreur chargement logo API');">
                            <div class="logo-fallback" style="display: none;">${logoText}</div>
                        ` : `
                            <div class="logo-fallback">${logoText}</div>
                        `}
                        <div class="company-info-detail">
                            <div class="company-name">${company.name}</div>
                            <div class="company-website">${company.site_web}</div>
                        </div>
                        </div>
                    <div class="document-badge">
                        <div class="doc-type">DEVIS</div>
                        <div class="doc-number">N° ${devis.numero_proforma}</div>
                        <div class="status-badge ${statut.class}">${statut.label}</div>
                    </div>
                </div>

                <!-- Coordonnées société -->
                <div style="font-size: 0.9rem; color: #4a5568; margin: 15px 0 20px 0; padding: 12px 0; border-bottom: 2px solid #4361ee;">
                    <span style="margin-right: 25px;"> ${company.address}</span>
                    <span style="margin-right: 25px;"> ${company.phone}</span>
                    <span style="margin-right: 25px;">✉ ${company.email}</span>
                </div>

                <!-- Client -->
                <div class="client-section">
                    <div class="client-info">
                        <h3>CLIENT</h3>
                        <div class="client-name">${devis.client_nom || 'Client non spécifié'}</div>
                        <div class="client-details">
                            <span>Code: ${devis.code_client || ''}</span>
                            ${devis.client_telephone ? `<span> ${devis.client_telephone}</span>` : ''}
                            ${devis.client_email ? `<span>✉ ${devis.client_email}</span>` : ''}
                        </div>
                    </div>
                    <div class="document-dates">
                        <div class="date-item">
                            <span class="label">Date d'émission</span>
                            <span class="value">${formatDate(devis.date_proforma)}</span>
                        </div>
                        <div class="date-item">
                            <span class="label">Date de validité</span>
                            <span class="value ${estExpire ? 'expired' : ''}">${formatDate(devis.date_validite)}</span>
                        </div>
                        ${!estExpire ? `
                            <div class="validity-badge">
                                Valable encore ${joursRestant} jours
                            </div>
                        ` : joursRestant < 0 ? `
                            <div class="validity-badge expired">
                                Expiré depuis ${Math.abs(joursRestant)} jours
                            </div>
                        ` : ''}
                    </div>
                </div>

                <!-- Notes -->
                ${devis.notes ? `
                    <div class="notes-section">
                        <strong>Note :</strong> ${devis.notes}
                    </div>
                ` : ''}

                <!-- Tableau des produits -->
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Réf.</th>
                                <th>Désignation</th>
                                <th class="text-center">Qté</th>
                                <th class="amount-cell">Prix HT</th>
                                <th class="text-center">Remise</th>
                                <th class="amount-cell">Total HT</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${devis.lignes?.map(ligne => `
                                <tr>
                                    <td><span class="ref-cell">${ligne.reference || ''}</span></td>
                                    <td>${ligne.designation || ''}</td>
                                    <td class="text-center">${ligne.quantite || 0}</td>
                                    <td class="amount-cell">${formatCurrency(ligne.prix_unitaire_ht || 0)}</td>
                                    <td class="text-center">${ligne.remise ? `${ligne.remise}%` : '-'}</td>
                                    <td class="amount-cell">${formatCurrency(ligne.montant_ligne_ht || 0)}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>

                <!-- Totaux -->
                <div class="totals-wrapper">
                    <div class="totals-card">
                        <div class="total-line">
                            <span class="label">Total HT</span>
                            <span class="value">${formatCurrency(devis.montant_ht || 0)}</span>
                        </div>
                        ${devis.montant_tva > 0 ? `
                            <div class="total-line">
                                <span class="label">TVA (${taxes.tva_active ? taxes.tva_taux : 0}%)</span>
                                <span class="value">${formatCurrency(devis.montant_tva || 0)}</span>
                            </div>
                        ` : ''}
                        ${devis.montant_css > 0 ? `
                            <div class="total-line">
                                <span class="label">CSS (${taxes.css_active ? taxes.css_taux : 0}%)</span>
                                <span class="value">${formatCurrency(devis.montant_css || 0)}</span>
                            </div>
                        ` : ''}
                        ${devis.remise_globale > 0 ? `
                            <div class="total-line">
                                <span class="label">Remise globale</span>
                                <span class="value">-${formatCurrency(devis.remise_globale)}</span>
                            </div>
                        ` : ''}
                        <div class="total-line highlight">
                            <span class="label">TOTAL TTC</span>
                            <span class="value">${formatCurrency(devis.net_a_payer || 0)}</span>
                        </div>
                    </div>
                </div>

                <!-- Pied de page -->
                <div class="document-footer">
                    <div class="legal-info">
                        <span>RC: ${company.rc}</span>
                        <span>NIF: ${company.nif}</span>
                        <span>Patente: ${company.patente}</span>
                    </div>
                    <div class="signature-area">
                        <div>Cachet et signature</div>
                        <div class="signature-line">____________________</div>
                    </div>
                </div>
            </div>
        </body>
        </html>
    `;
};
    // Fonction d'impression
const handlePrint = async () => {
    // Générer le HTML
    const html = genererHTMLImpression();
    
    // Ouvrir la fenêtre
    const printWindow = window.open('', '_blank');
    printWindow.document.write(html);
    printWindow.document.close();
    
    // Attendre que toutes les images soient chargées
    await new Promise((resolve) => {
        const images = printWindow.document.images;
        const totalImages = images.length;
        let loadedImages = 0;
        
        if (totalImages === 0) {
            resolve();
            return;
        }
        
        Array.from(images).forEach(img => {
            if (img.complete) {
                loadedImages++;
                if (loadedImages === totalImages) resolve();
            } else {
                img.onload = () => {
                    loadedImages++;
                    if (loadedImages === totalImages) resolve();
                };
                img.onerror = () => {
                    loadedImages++;
                    if (loadedImages === totalImages) resolve();
                };
            }
        });
    });
    
    // Une fois toutes les images chargées, imprimer
    printWindow.focus();
    printWindow.print();
    showSuccess("Document ouvert pour impression");
};
   
    // Fonction pour télécharger le PDF
    const handleGeneratePDF = async () => {
        setGeneratingPDF(true);
        try {
            if (!logoBase64) {
                await loadLogoBase64();
            }
            const html = genererHTMLImpression();
            const printWindow = window.open('', '_blank');
            printWindow.document.write(html);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            showSuccess("Document généré avec succès ✅");
        } catch (error) {
            console.error("Erreur PDF:", error);
            showError(`Erreur PDF: ${error.message}`);
        } finally {
            setGeneratingPDF(false);
        }
    };

    const getStatutBadge = (statut) => {
        const configs = {
            brouillon: { color: 'secondary', icon: 'ri-draft-line', label: 'Brouillon' },
            envoye: { color: 'primary', icon: 'ri-send-plane-line', label: 'Envoyé' },
            accepte: { color: 'success', icon: 'ri-check-double-line', label: 'Accepté' },
            refuse: { color: 'danger', icon: 'ri-close-circle-line', label: 'Refusé' },
            converti_facture: { color: 'info', icon: 'ri-file-list-3-line', label: 'Converti' }
        };
        const config = configs[statut] || configs.brouillon;
        
        // Vérifier si le devis est expiré
        if (statut === 'envoye' && devis && new Date(devis.date_validite) < new Date()) {
            return (
                <Badge bg="warning" className="px-4 py-2 fs-6 statut-badge" style={{
                    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                    border: 'none',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}>
                    <i className="ri-time-line me-2"></i>
                    Expiré
                </Badge>
            );
        }

        return (
            <Badge 
                bg={config.color} 
                className="px-4 py-2 fs-6 statut-badge"
                style={{
                    background: `linear-gradient(135deg, var(--bs-${config.color}), var(--bs-${config.color}-dark))`,
                    border: 'none',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}
            >
                <i className={`${config.icon} me-2`}></i>
                {config.label}
            </Badge>
        );
    };

    const ActionButton = ({ variant, icon, onClick, tooltip, disabled = false, loading = false }) => (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${variant}`}>{tooltip}</Tooltip>}
        >
            <Button
                variant={variant}
                onClick={onClick}
                disabled={disabled || loading}
                className="action-btn"
            >
                {loading ? <Spinner size="sm" /> : <i className={icon}></i>}
            </Button>
        </OverlayTrigger>
    );

    const estExpire = devis && new Date(devis.date_validite) < new Date();

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                            <p className="mt-3 text-muted">Chargement du devis...</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error || !devis) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <Alert variant="danger" className="text-center py-5">
                        <i className="ri-error-warning-line fs-48 mb-3 d-block"></i>
                        <h4>{error || "Devis non trouvé"}</h4>
                        <Button 
                            variant="outline-danger" 
                            className="mt-3"
                            onClick={() => navigate('/ventes/devisListe')}
                        >
                            <i className="ri-arrow-left-line me-2"></i>
                            Retour aux devis
                        </Button>
                    </Alert>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4" ref={printRef}>
                <div className="container-fluid">
                    {/* Alertes */}
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible className="mb-4 alert-modern">
                            <i className="ri-checkbox-circle-line me-2 fs-5"></i>
                            {successMessage}
                        </Alert>
                    )}
                    
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible className="mb-4 alert-modern">
                            <i className="ri-error-warning-line me-2 fs-5"></i>
                            {errorMessage}
                        </Alert>
                    )}

                    {/* En-tête */}
                    <div className="page-header-modern mb-4 fade-in">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3">
                                <div className="page-icon bg-primary-soft">
                                    <i className="ri-file-copy-line text-primary"></i>
                                </div>
                                <div>
                                    <h1 className="page-title mb-1">Détail du devis</h1>
                                    <p className="page-subtitle mb-0">
                                        Consultez et gérez les informations du devis
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex gap-2 no-print">
                                <ActionButton
                                    variant="outline-secondary"
                                    icon="ri-arrow-left-line"
                                    onClick={() => navigate('/ventes/devisListe')}
                                    tooltip="Retour à la liste"
                                />
                                <ActionButton
                                    variant="outline-primary"
                                    icon="ri-printer-line"
                                    onClick={handlePrint}
                                    tooltip="Imprimer"
                                />
                                <ActionButton
                                    variant="outline-danger"
                                    icon="ri-file-pdf-line"
                                    onClick={handleGeneratePDF}
                                    tooltip="Télécharger PDF"
                                    loading={generatingPDF}
                                    disabled={generatingPDF}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Carte d'identité du devis */}
                    <Card className="border-0 shadow-sm mb-4 facture-identity-card">
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col md={4} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-primary-soft">
                                            <i className="ri-barcode-line text-primary"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">N° Devis</small>
                                            <h4 className="mb-0">{devis.numero_proforma}</h4>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-success-soft">
                                            <i className="ri-calendar-line text-success"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">Date</small>
                                            <h5 className="mb-0">{formatDate(devis.date_proforma)}</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-warning-soft">
                                            <i className="ri-time-line text-warning"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">Valide jusqu'au</small>
                                            <h5 className={`mb-0 ${estExpire ? 'text-danger' : ''}`}>
                                                {formatDate(devis.date_validite)}
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="text-end">
                                        {getStatutBadge(devis.statut)}
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* Informations client et société */}
                    <Row className="g-4 mb-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-building-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Informations société</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="company-info">
                                        <h4 className="fw-bold text-primary mb-3">GESTION STOCK</h4>
                                        <p className="mb-2">
                                            <i className="ri-map-pin-line text-muted me-2"></i>
                                            {companie.address}
                                        </p>
                                        <p className="mb-2">
                                            <i className="ri-phone-line text-muted me-2"></i>
                                            {companie.phone}
                                        </p>
                                        <p className="mb-2">
                                            <i className="ri-mail-line text-muted me-2"></i>
                                            {companie.email}
                                        </p>
                                        <p className="mb-0">
                                            <i className="ri-global-line text-muted me-2"></i>
                                            {companie.site_web}   
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-user-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Informations client</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="client-info">
                                        <h4 className="fw-bold mb-3">{devis.client_nom}</h4>
                                        <p className="mb-2">
                                            <i className="ri-barcode-line text-muted me-2"></i>
                                            Code: {devis.code_client}
                                        </p>
                                        {devis.client_telephone && (
                                            <p className="mb-2">
                                                <i className="ri-phone-line text-muted me-2"></i>
                                                {devis.client_telephone}
                                            </p>
                                        )}
                                        {devis.client_email && (
                                            <p className="mb-2">
                                                <i className="ri-mail-line text-muted me-2"></i>
                                                {devis.client_email}
                                            </p>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Notes */}
                    {devis.notes && (
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header className="bg-transparent border-0 pt-4">
                                <div className="d-flex align-items-center">
                                    <div className="section-icon">
                                        <i className="ri-file-text-line text-primary"></i>
                                    </div>
                                    <h5 className="mb-0 ms-2">Notes</h5>
                                    </div>
                            </Card.Header>
                            <Card.Body>
                                <p className="mb-0">{devis.notes}</p>
                            </Card.Body>
                        </Card>
                    )}

                    {/* Lignes de devis */}
                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Header className="bg-transparent border-0 pt-4">
                            <div className="d-flex align-items-center">
                                <div className="section-icon">
                                    <i className="ri-shopping-cart-line text-primary"></i>
                                </div>
                                <h5 className="mb-0 ms-2">Détail des produits</h5>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <div className="table-responsive">
                                <Table className="mb-0 align-middle modern-table">
                                    <thead>
                                        <tr>
                                            <th>Référence</th>
                                            <th style={{minWidth:'190px'}}>Désignation</th>
                                            <th className="text-center">Qté</th>
                                            <th className="text-end">Prix unitaire HT</th>
                                            <th className="text-center">Remise</th>
                                            <th className="text-end">Total HT</th>
                                            <th className="text-center">TVA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {devis.lignes?.map((ligne, index) => (
                                            <tr key={index} className="product-row">
                                                <td>
                                                    <Badge bg="light" text="dark" className="font-mono px-3 py-2">
                                                        {ligne.reference}
                                                    </Badge>
                                                </td>
                                                <td className="fw-semibold">{ligne.designation}</td>
                                                <td className="text-center">{formatNumber(ligne.quantite)}</td>
                                                <td className="text-end">{formatCurrency(ligne.prix_unitaire_ht)}</td>
                                                <td className="text-center">{ligne.remise ? `${ligne.remise}%` : '-'}</td>
                                                <td className="text-end fw-bold text-primary">
                                                    {formatCurrency(ligne.montant_ligne_ht)}
                                                </td>
                                                <td className="text-center text-warning">
                                                    {ligne.tva_taux || (taxes.tva_active ? taxes.tva_taux : 0)}%
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Récapitulatif */}
                    <Row className="g-4 mb-4">
                        <Col md={8}>
                            <Card className="border-0 shadow-sm">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-calculator-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Récapitulatif financier</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="recap-modern">
                                        <div className="recap-row">
                                            <span>Total HT</span>
                                            <span className="fw-bold">{formatCurrency(devis.montant_ht)}</span>
                                        </div>
                                        <div className="recap-row">
                                            <span>TVA ({taxes.tva_active ? taxes.tva_taux : 0}%)</span>
                                            <span className="fw-bold text-warning">{formatCurrency(devis.montant_tva)}</span>
                                        </div>
                                        <div className="recap-row">
                                            <span>CSS ({taxes.css_active ? taxes.css_taux : 0}%)</span>
                                            <span className="fw-bold text-info">{formatCurrency(devis.montant_css)}</span>
                                        </div>
                                        {devis.remise_globale > 0 && (
                                            <div className="recap-row text-success">
                                                <span>Remise globale</span>
                                                <span className="fw-bold">-{formatCurrency(devis.remise_globale)}</span>
                                            </div>
                                        )}
                                        <div className="recap-divider"></div>
                                        <div className="recap-row highlight">
                                            <span className="h5">Total TTC</span>
                                            <span className="h4 text-primary">{formatCurrency(devis.net_a_payer)}</span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-information-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Actions</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="d-grid gap-2">
                                        {devis.statut === 'accepte' && (
                                            <Button 
                                                variant="success" 
                                                size="lg"
                                                className="btn-gradient-success"
                                                onClick={() => setShowConvertModal(true)}
                                            >
                                                <i className="ri-file-list-3-line me-2"></i>
                                                Convertir en facture
                                            </Button>
                                        )}
                                        {devis.statut === 'brouillon' && (
                                            <Button 
                                                variant="primary" 
                                                size="lg"
                                                className="btn-gradient"
                                                onClick={() => navigate(`/ventes/devis/modifier/${devis.id_proforma}`)}
                                            >
                                                <i className="ri-pencil-line me-2"></i>
                                                Modifier le devis
                                            </Button>
                                        )}
                                        {devis.statut !== 'converti_facture' && devis.statut !== 'refuse' && (
                                            <Button 
                                                variant="warning" 
                                                size="lg"
                                                className="btn-gradient-warning"
                                                onClick={() => alert("Fonctionnalité d'envoi à venir")}
                                            >
                                                <i className="ri-mail-send-line me-2"></i>
                                                Envoyer par email
                                            </Button>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>

            {/* Modal de conversion */}
            <Modal show={showConvertModal} onHide={() => setShowConvertModal(false)} centered className="modern-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="ri-file-list-3-line me-2 text-success"></i>
                        Convertir en facture
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Êtes-vous sûr de vouloir convertir ce devis en facture ?</p>
                    <p className="text-muted small">
                        Une fois converti, le devis sera marqué comme "Converti" et une nouvelle facture sera créée.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConvertModal(false)}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleConvertirEnFacture} disabled={saving}>
                        {saving ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Conversion...
                            </>
                        ) : (
                            <>
                                <i className="ri-check-line me-2"></i>
                                Confirmer la conversion
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <style>{`
                /* Styles pour l'impression */
                @media print {
                    .no-print {
                        display: none !important;
                    }
                    .main {
                        padding: 0 !important;
                    }
                    .card {
                        box-shadow: none !important;
                        border: 1px solid #dee2e6 !important;
                        break-inside: avoid;
                        page-break-inside: avoid;
                    }
                    .statut-badge {
                        background: #f8f9fa !important;
                        color: #000 !important;
                        border: 1px solid #dee2e6 !important;
                    }
                    .table {
                        font-size: 10px;
                    }
                }

                /* Animations */
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .fade-in {
                    animation: fadeIn 0.5s ease-out;
                }

                /* En-tête moderne */
                .page-header-modern {
                    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
                    padding: 1.5rem;
                    border-radius: 20px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                }

                .page-icon {
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #4361ee20, #80b3ff20);
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 2rem;
                }

                .page-title {
                    font-size: 1.6rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;
                }

                .page-subtitle {
                    color: #64748b;
                    font-size: 0.95rem;
                }

                /* Carte d'identité */
                .facture-identity-card {
                    border-radius: 16px !important;
                    background: white;
                }

                .identity-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                }

                .bg-primary-soft { background: #4361ee20; }
                .bg-success-soft { background: #10b98120; }
                .bg-warning-soft { background: #f59e0b20; }

                /* Icônes de section */
                .section-icon {
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #4361ee20, #80b3ff20);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.3rem;
                }

                /* Tableau moderne */
                .modern-table thead th {
                    background: #f8fafc;
                    color: #1e293b;
                    font-weight: 600;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    padding: 1rem;
                    border-bottom: 2px solid #e2e8f0;
                }

                .modern-table tbody td {
                    padding: 1rem;
                    vertical-align: middle;
                    border-bottom: 1px solid #e2e8f0;
                }

                .product-row {
                    transition: all 0.2s ease;
                }

                .product-row:hover {
                    background: #f8fafc;
                }

                /* Récapitulatif moderne */
                .recap-modern {
                    padding: 1rem;
                }

                .recap-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 0.5rem 0;
                    border-bottom: 1px dashed #e2e8f0;
                }

                .recap-row:last-child {
                    border-bottom: none;
                }

                .recap-row.highlight {
                    background: #f8fafc;
                    padding: 0.75rem;
                    border-radius: 8px;
                    margin: 0.5rem 0;
                }

                .recap-divider {
                    height: 2px;
                    background: linear-gradient(90deg, #e2e8f0, transparent);
                    margin: 0.5rem 0;
                }

                .recap-row.total {
                    padding: 0.75rem 0;
                }

                .recap-row.final {
                    background: #4361ee10;
                    padding: 1rem;
                    border-radius: 12px;
                    margin-top: 0.5rem;
                }

                /* Liste des paiements */
                .paiements-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }

                .paiement-item {
                    padding: 1rem;
                    background: #f8fafc;
                    border-radius: 12px;
                    transition: all 0.2s ease;
                }

                .paiement-item:hover {
                    transform: translateX(5px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }

                /* Boutons d'action */
                .action-btn {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    border: 1px solid #e2e8f0;
                    background: white;
                    color: #64748b;
                }

                .action-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }

                .btn-gradient-success {
                    background: linear-gradient(135deg, #10b981, #059669);
                    border: none;
                    color: white;
                }

                .btn-gradient-success:hover {
                    background: linear-gradient(135deg, #059669, #047857);
                }

                .btn-gradient-warning {
                    background: linear-gradient(135deg, #f59e0b, #d97706);
                    border: none;
                    color: white;
                }

                .btn-gradient-warning:hover {
                    background: linear-gradient(135deg, #d97706, #b45309);
                }

                /* Alertes modernes */
                .alert-modern {
                    border: none;
                    border-radius: 12px;
                    padding: 1rem 1.5rem;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }

                /* Modals modernes */
                .modern-modal .modal-content {
                    border: none;
                    border-radius: 20px;
                    overflow: hidden;
                }

                .modern-modal .modal-header {
                    background: linear-gradient(135deg, #f8fafc, #ffffff);
                    border-bottom: 1px solid #e2e8f0;
                    padding: 1.5rem;
                }

                .modern-modal .modal-header .modal-title {
                    font-weight: 700;
                    color: #1e293b;
                }

                .modern-modal .modal-body {
                    padding: 1.5rem;
                }

                .modern-modal .modal-footer {
                    border-top: 1px solid #e2e8f0;
                    padding: 1.5rem;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .page-title {
                        font-size: 1.3rem;
                    }
                    .page-icon {
                        width: 50px;
                        height: 50px;
                        font-size: 1.5rem;
                    }
                    .identity-icon {
                        width: 40px;
                        height: 40px;
                        font-size: 1.2rem;
                    }
                }
            `}</style>
        </>
    );
}